<template>
  <v-row justify="center" style="margin:0;">
        <img
          :src="config.type === 'video' ? config.screenshot : config.url"
          style="width: 80px!important;cursor:pointer;"
          :style="{ height: prevHeight ? `${prevHeight}px` : '45px' }"
          @click="dialog = true"
        />
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!--template v-slot:activator="{ on, attrs }">
        <img
          :src="config.type === 'video' ? config.screenshot : config.url"
          style="width: 80px!important;cursor:pointer;"
          :style="{ height: prevHeight ? `${prevHeight}px` : '45px' }"
          v-bind="attrs"
          v-on="on"
        />
      </template-->
      <v-card>
        <v-toolbar
          dark
          color="primary"
          elevation="0"
          style="border-radius:0"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
            >
              {{ $t('common.close', locale)}}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-row no-gutters>
          <v-col
            cols="12"
            xs="12"
            style="padding-top: 20px;"
          >
            <center>
              <v-card
                v-if="size && content"
                elevation="2"
                class="main-template-preview" 
                :style="{ width: `${size.width}px`, height: `${size.height}px` }"
              >
                <div
                  v-html="content.content"
                />
              </v-card>
            </center>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { v4 as uuidv4 } from 'uuid'
export default {
  components: {
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    prevHeight: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    size: null,
    content: null,
  }),
  computed: {
    url () {
      return this.config.url
    },
  },
  watch: {
    'config.url' () {
      this.handlePrepare()
    },
    dialog () {
      this.handlePrepare()
    },
  },
  mounted () {
    this.handlePrepare()
  },
  methods: {
    async handleGetSize () {
      return this.scaleSize(this.config)
    },
    prepareMediaContent (type, id, name, url, description, duration) {
      if (!duration || duration.length === 0) duration = 1
      const content = type === 'video' ? `<video id="${id}" src="${url}" width="100%" height="100%" loop
            autoplay="autoplay" muted defaultmuted playsinline />`
        : `<img src="${url}" width="100%" height="100%">`

      return {
        content,
        duration,
        type,
        id,
        name,
      }
    },

    async handlePrepare () {
      this.content = null
      if (!this.dialog) return
      if (!this.url || this.url.length < 4) return
      this.size = await this.handleGetSize()
      if (!this.size) {
        alert(' URL no permitida...')
        return
      }
      
      this.content = this.prepareMediaContent(this.config.type, uuidv4(), '',  this.url, '', 10000)
    },
    scaleSize (v, maxH) {
      const maxHeight = maxH ? maxH : 450
      if (v.height > maxHeight) {
        v.width = v.width * maxHeight / v.height
        v.height = maxHeight
      }
      return v
    },
    handleClose () {
      this.xml = null
      this.showError = false
    },
  },
}
</script>

<style>
* {
  font-family: 'Roboto';
}
</style>


